//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

const BytesToMB = 1 / 1048576;

export async function getFileSizeBytes(fileUrl: string): Promise<number | undefined> {
  try {
    const res = await fetch(fileUrl, {
      method: 'HEAD',
      cache: 'no-cache',
    });

    const size = res.headers.get('content-length');
    return size ? +size : 0;
  } catch (e) {
    return undefined;
  }
}

export async function getFileSizeMB(fileUrl: string): Promise<number | undefined> {
  const fileSize = await getFileSizeBytes(fileUrl);
  if (fileSize) {
    return fileSize * BytesToMB;
  } else {
    return fileSize;
  }
}
